import { ButtonProps } from "@cmsgov/ds-medicare-gov";
import Button, { ButtonProps as CustomButtonProps } from "../../common/components/button";

type SubmitButtonProps = Omit<ButtonProps, 'type' | 'disabled' | 'variation'> & {
    isLoading?: boolean
    mfaAnalyticsData: CustomButtonProps['mfaAnalyticsData']
}

export const SubmitButton = (props: SubmitButtonProps) => {
    const { children, isLoading = false, ...otherProps } = props;
    return <>
        <Button
            disabled={isLoading}
            type="submit"
            isLoading={isLoading}
            variation={'solid'}
            {...otherProps}
        >
            {children}
        </Button>
    </>;
};
